export default "__VITE_ASSET__DGb50Civ__"